import { defineStore } from 'pinia'

export const useCasinoStore = defineStore('casino', {
  state: () => ({

    launchGame: JSON.parse(localStorage.getItem('launchGame')) || {}

  }),

  actions: {

    setLaunchGame(launchGame) {

      this.launchGame = launchGame
      this.saveObject('launchGame', launchGame)
    },

    saveObject: function(key, value) {

      value = JSON.stringify(value)

      if (typeof Storage !== 'undefined') {

        localStorage.setItem(key, value)

      } else {

        document.cookie = key + '=' + value
      }
    },

    getLaunchGame: function() {

      var launchGame = this.getObject('launchGame')

      if (!launchGame || launchGame === '' || launchGame === '') {

        launchGame = {}

      }

      return launchGame
    },

    getObject: function(key) {

      if (typeof Storage !== 'undefined') {

        var post = localStorage.getItem(key)

        if (post === undefined) {

          return false

        }

        return JSON.parse(post)

      } else {

        return JSON.parse(this.getCookie(key))

      }
    },

    getValue: function(key) {
      if (typeof Storage !== 'undefined') {
        var post = localStorage.getItem(key)
        if (post == 'undefined') {
          return ''
        }

        return post
      } else {
        return this.getCookie(key)
      }
    }

  }
})
